import React, { useEffect, useState } from 'react';
import { Select, Spin, Modal, Form, Input, } from 'antd';
import SideNav from '../company-settings/side-nav/component';
import { axiosInstanceB2B, Toaster } from '@share/utils';
import { useDispatch, useSelector } from 'react-redux';
import { accountSettingActions, IAccountSettingState } from '@store/slices';
import './style.scss';
import { Urls } from '@share/constants';
import { ILoginState } from '@share/store/slices';
import { BlueButton } from '@share/components';
import { FormattedMessage, useIntl } from 'react-intl';

interface IMapStateToProps {
  loginStore: ILoginState;
  accountSettingStore: IAccountSettingState;
}
interface ResponseType {
  preferences: { key: string; value: string | number }[];
}
function CompanyTravelComponent() {
  const formData = new FormData();
  const dispatch = useDispatch();
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const saveLoading = useSelector((state: IMapStateToProps) => state.accountSettingStore);
  const [hotelMaxBudget, setHotelMaxBudget] = useState<string>('');
  const [maximumCarAmount, setMaximumCarAmount] = useState<string>('');
  const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(true);
  const [carsIsCollapseOpen, setCarsIsCollapseOpen] = useState<boolean>(true);
  const [departments, setDepartments] = useState([]);
  const [departmentId, setDepartmentId] = useState<string>('');
  const { Option } = Select;
  const intl = useIntl();
  const [response, setResponse] = useState<ResponseType>({
    preferences: [],
  });
  const [BusinessPreferences, setBusinessPreferences] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [starSettings, setStarSettings] = useState({
    hotel_max_stars: [false, false, false, false, false],
  });
  const [propertySettings, setPropertySettings] = useState({
    hotels: false,
    rentals: false,
    motel: false,
    hotel_locked_types: [],
  });
  const [maxBudgetSettings, setMaxBudgetSettings] = useState({
    budget: false,
  });
  const [carBudgetSettings, setCarBudgetSettings] = useState({
    maximumCars: false,
  });
  const [carSettings, setCarSettings] = useState<{
    budget: boolean;
    avis: boolean;
    hertz: boolean;
    payless: boolean;
    enterprise: boolean;
    dollarUs: boolean;
    thriftyUs: boolean;
    sixt: boolean;
    fox: boolean;
    alamo: boolean;
    national: boolean;
    car_allow_rental_brand: string[];
  }>({
    budget: false,
    avis: false,
    hertz: false,
    payless: false,
    enterprise: false,
    dollarUs: false,
    thriftyUs: false,
    sixt: false,
    fox: false,
    alamo: false,
    national: false,
    car_allow_rental_brand: []
  });

  const toggleCollapse = () => {
    setIsCollapseOpen(!isCollapseOpen);
  };
  const carsToggleCollapse = () => {
    setCarsIsCollapseOpen(!carsIsCollapseOpen);
  };


  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    const index = parseInt(id.match(/\d+/)?.[0] || '-1', 10) - 1;

    if (index >= 0) {
      setStarSettings(prev => {
        const updatedStars = [...prev.hotel_max_stars];
        updatedStars[index] = checked;

        const selectedStarValues = updatedStars
          .map((isChecked, idx) => (isChecked ? idx + 1 : null))
          .filter((v): v is number => v !== null)
          .join(',');

        try {
          const updatedPreferences = [
            ...response.preferences.filter(p => p.key !== 'hotel_max_stars'),
            {
              key: 'hotel_max_stars',
              value: selectedStarValues,
            },
          ];
          if (selectedStarValues) {
            setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'hotel_max_stars'), {
              key: 'hotel_max_stars',
              value: selectedStarValues,
            }]);
          }
          else {
            setBusinessPreferences(BusinessPreferences.filter(p => p.key !== 'hotel_max_stars'));
          }
          response.preferences = updatedPreferences;
        } catch (error: any) {
          Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
        }

        return { hotel_max_stars: updatedStars };
      });
    }
  };


  const handlePropertyChange = async (event: any) => {
    const { id, checked } = event.target;
    let updatedTypes;
    if (checked) {
      updatedTypes = [...propertySettings.hotel_locked_types, id];
    } else {
      updatedTypes = propertySettings.hotel_locked_types.filter((type: any) => type !== id);
    }
    setPropertySettings((prevState: any) => ({
      ...prevState,
      hotel_locked_types: updatedTypes,
      [id]: checked,
    }));

    try {
      response.preferences = [
        ...response.preferences,
        {
          key: 'hotel_locked_types',
          value: JSON.stringify(updatedTypes),
        },
      ];
      if (updatedTypes.length > 0) {
        setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'hotel_locked_types'), {
          key: 'hotel_locked_types',
          value: JSON.stringify(updatedTypes),
        }]);
      }
      else {
        setBusinessPreferences(BusinessPreferences.filter(p => p.key !== 'hotel_locked_types'));
      }
    } catch (error: any) {
      Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
    }
  };

  const handleBudgetChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    if (!checked) {
      setHotelMaxBudget('');
      try {
        response.preferences = [
          ...response.preferences,
          { key: 'hotel_max_budget', value: '' },
        ]
        setBusinessPreferences(BusinessPreferences.filter(p => p.key !== 'hotel_max_budget'));
      } catch (error) {
        Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
      } 
    }
    setMaxBudgetSettings((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
  };

  const handleCarBudgetChange = async (event: any) => {
    const { id, checked } = event.target;
    if (!checked) {
      setMaximumCarAmount('');
      try {
        response.preferences = [
          ...response.preferences,
          {
            key: 'car_max_budget',
            value: '',
          },
        ];
        setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'car_max_budget'), {
          key: 'car_max_budget',
          value: '',
        }]);
      } catch (error) {
        Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
      }
    }
    setCarBudgetSettings((prevState) => ({
      ...prevState,
      [id]: checked,
    }));
  };
  const handleCarChange = async () => {
    try {
      response.preferences = [
        ...response.preferences,
        { key: 'car_max_budget', value: maximumCarAmount },
      ];
      setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'car_max_budget'), {
        key: 'car_max_budget',
        value: maximumCarAmount,
      }]);
    } catch (error: any) {
      Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
    }
  };

  const handleCarToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    let updatedTypes;
    if (checked) {
      updatedTypes = [...carSettings.car_allow_rental_brand, id];
    } else {
      updatedTypes = carSettings.car_allow_rental_brand.filter((type: any) => type !== id);
    }
    setCarSettings((prevSettings) => ({
      ...prevSettings,
      car_allow_rental_brand: updatedTypes,
      [id]: checked,
    }));
    response.preferences = [
      ...response.preferences,
      {
        key: 'car_allow_rental_brand',
        value: JSON.stringify(updatedTypes),
      },
    ];
    if (updatedTypes.length > 0) {
      setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'car_allow_rental_brand'), {
        key: 'car_allow_rental_brand',
        value: JSON.stringify(updatedTypes),
      }]);
    }
    else {
      setBusinessPreferences([
        ...BusinessPreferences.filter(p => p.key !== 'car_allow_rental_brand'),
        {
          key: 'car_allow_rental_brand',
          value: '',
        },
      ]);
    }
    
  };
  

  const switchOptions = Array.from({ length: 5 }, (_, index) => ({
    id: `${index + 1}Star`,
    label: `${index + 1} ${intl.formatMessage({ id: 'star' })}`,
    checked: starSettings.hotel_max_stars[index],
  }));
  const propertyOptions = [
    {
      id: 'hotels',
      label: intl.formatMessage({ id: 'allow.only.hotels' }),
      checked: propertySettings.hotels,
    },
    {
      id: 'rentals',
      label: intl.formatMessage({ id: 'allow.vacation.rentals' }),
      checked: propertySettings.rentals,
    },
    {
      id: 'motel',
      label: intl.formatMessage({ id: 'allow.motels' }),
      checked: propertySettings.motel,
    },
  ];
  const budgetOptions = [
    {
      id: 'budget',
      label: intl.formatMessage({ id: 'enable.max.budget' }),
      checked: maxBudgetSettings.budget,
    },
  ];
  const carBudgetOptions = [
    {
      id: 'maximumCars',
      label: intl.formatMessage({ id: 'enable.max.budget.car' }),
      checked: carBudgetSettings.maximumCars,
    },
  ];

  const carOptions = [
    {
      id: 'budget',
      label: intl.formatMessage({ id: 'budget' }),
      checked: carSettings.budget,
    },
    {
      id: 'avis',
      label: intl.formatMessage({ id: 'avis' }),
      checked: carSettings.avis,
    },
    {
      id: 'hertz',
      label: intl.formatMessage({ id: 'hertz' }),
      checked: carSettings.hertz,
    },
    {
      id: 'payless',
      label: intl.formatMessage({ id: 'payless' }),
      checked: carSettings.payless,
    },
    {
      id: 'enterprise',
      label: intl.formatMessage({ id: 'enterprise' }),
      checked: carSettings.enterprise,
    },
    {
      id: 'dollarUs',
      label: intl.formatMessage({ id: 'dollar.us' }),
      checked: carSettings.dollarUs,
    },
    {
      id: 'thriftyUs',
      label: intl.formatMessage({ id: 'thrifty.us' }),
      checked: carSettings.thriftyUs,
    },
    {
      id: 'sixt',
      label: intl.formatMessage({ id: 'sixt' }),
      checked: carSettings.sixt,
    },
    {
      id: 'fox',
      label: intl.formatMessage({ id: 'fox' }),
      checked: carSettings.fox,
    },
    {
      id: 'alamo',
      label: intl.formatMessage({ id: 'alamo' }),
      checked: carSettings.alamo,
    },
    {
      id: 'national',
      label: intl.formatMessage({ id: 'national' }),
      checked: carSettings.national,
    },
  ];

  const [tierError, setTierError] = useState<string>(''); // Error message
  const [carError, setCarError] = useState<string>(''); // Error message

  const handleTierInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Validation: Only allow numbers
    if (/^\d*$/.test(value)) {
      setHotelMaxBudget(value);
      setTierError('');
      response.preferences = [
        ...response.preferences,
        { key: 'hotel_max_budget', value: value },
      ];
      setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'hotel_max_budget'), {
        key: 'hotel_max_budget',
        value: value,
      }]);
    } else {
      setHotelMaxBudget(value);
      setTierError('Please enter a valid number.');
    }
  };
  const handleCarInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (/^\d*$/.test(value)) {
      setMaximumCarAmount(value);
      response.preferences = [
        ...response.preferences,
        { key: 'car_max_budget', value: value },
      ]
      setBusinessPreferences([...BusinessPreferences.filter(p => p.key !== 'car_max_budget'), {
        key: 'car_max_budget',
        value: value,
      }]);
      setCarError('');
    } else {
      setMaximumCarAmount(value);
      setCarError('Please enter a valid number.');
    }
  };

  const handleSave = async () => {
    try {
      if (departmentId) {
        if (BusinessPreferences.length > 0) { 
          const updatedBusinessPreferences = BusinessPreferences.map((item) => {
            if (
              item.key === 'car_allow_rental_brand' &&
              typeof item.value === 'string'
            ) {
              try {
                const arr = JSON.parse(item.value);
                if (Array.isArray(arr)) {
                  const updatedArr = arr.map((brand: string) => {
                    if (brand === 'thriftyUs') return 'thrifty us';
                    if (brand === 'dollarUs') return 'dollar us';
                    return brand;
                  });
                  return { ...item, value: JSON.stringify(updatedArr) };
                }
              } catch (e) {
                return item;
              }
            }
            return item;
          });
          const payload = {
            departmentId: form.getFieldValue('departmentId'),
            preferences: updatedBusinessPreferences,
          }
          const result = await axiosInstanceB2B.post(`${Urls.SaveDepartmentPreference}`, payload);
          if (result?.status === 200) {
            Toaster.success(intl.formatMessage({ id: 'success.preferences.updated' }));
          } else {
            Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
          }
        }
        else {
          Toaster.warning(intl.formatMessage({ id: 'department.delete.warning' }));
        }
      }
      else {
        dispatch(accountSettingActions.setLoading(true));

        response.preferences = response.preferences.map((item: any) => {
          if (
            item.key === 'car_allow_rental_brand' &&
            typeof item.value === 'string'
          ) {
            try {
              const arr = JSON.parse(item.value);
              if (Array.isArray(arr)) {
                const updatedArr = arr.map((brand: string) => {
                  if (brand === 'thriftyUs') return 'thrifty us';
                  if (brand === 'dollarUs') return 'dollar us';
                  return brand;
                });
                return { ...item, value: JSON.stringify(updatedArr) };
              }
            } catch (e) {
              return item;
            }
          }
          return item;
        });
        formData.append('query', JSON.stringify(response));
        const result = await axiosInstanceB2B.post(`/identity/account/save`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (result?.status === 200) {
          dispatch(accountSettingActions.setLoading(false));
          Toaster.success(intl.formatMessage({ id: 'success.preferences.updated' }));
        } else {
          dispatch(accountSettingActions.setLoading(false));
          Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
        }
      }
    } catch (error) {
      dispatch(accountSettingActions.setLoading(false));
      Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
    }
  }
  const fetchUserData = async () => {
    setLoading(true);
    try {
      const getAccountUser = await axiosInstanceB2B.get(
        `${Urls.FetchUserAccount}${login?.account?.id}`,
        {},
      );
      setResponse(getAccountUser?.data);
      dispatch(accountSettingActions.setPreferences(getAccountUser?.data?.preferences));
      const starKeys = Object.keys(starSettings)[0];
      const propertyKey = 'hotel_locked_types';
      const carKeys = ['car_allow_rental_brand'];
      const hotelMaxBudget = ['hotel_max_budget'];
      const carAmount = ['car_max_budget'];
      const filterData = getAccountUser?.data?.preferences?.map((item: any) => {
        if (item.key === starKeys) {
          setStarSettings(() => {
            const updatedStars = Array(5).fill(false);
            const selectedIndices = item.value
              .split(',')
              .map((v: string) => parseInt(v.trim(), 10) - 1)
              .filter((idx: number) => idx >= 0 && idx < 5);

            selectedIndices.forEach((idx:any) => {
              updatedStars[idx] = true;
            });

            return { hotel_max_stars: updatedStars };
          });
        }
        if (item.key === propertyKey) {
          const checked = item.value === 'true';
          const id = item.key;
          const parsedValue = JSON.parse(item.value);

          setPropertySettings((prevState) => ({
            ...prevState,
            hotel_locked_types: parsedValue,
            hotels: parsedValue.includes('hotels'),
            rentals: parsedValue.includes('rentals'),
            motel: parsedValue.includes('motel'),
          }));
        }
        if (carKeys.includes(item.key)) {
          const checked = item.value === 'true';
          const id = item.key;
          const parsedValue = JSON.parse(item.value);
            setCarSettings((prevState) => ({
              ...prevState,
              car_allow_rental_brand: parsedValue,
              budget: parsedValue.includes('budget'),
              avis: parsedValue.includes('avis'),
              hertz: parsedValue.includes('hertz'),
              payless: parsedValue.includes('payless'),
              enterprise: parsedValue.includes('enterprise'),
              dollarUs: parsedValue.includes('dollar us'),
              thriftyUs: parsedValue.includes('thrifty us'),
              sixt: parsedValue.includes('sixt'),
              fox: parsedValue.includes('fox'),
              alamo: parsedValue.includes('alamo'),
              national: parsedValue.includes('national'),
            }));
        }
        if (hotelMaxBudget.includes(item.key)) {
          const checked = true;
          const id = 'budget';
          if (item.value.length > 0) {
            setMaxBudgetSettings((prevState) => ({
              ...prevState,
              [id]: checked,
            }));

            setHotelMaxBudget(item.value);
          }
        }
        if (carAmount.includes(item.key)) {
          const checked = true;
          const id = 'maximumCars';
          if (item.value.length > 0) {
            setCarBudgetSettings((prevState) => ({
              ...prevState,
              [id]: checked,
            }));
            setMaximumCarAmount(item.value);
          }
        }
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };
  const fetchDepartments = async () => {
    try {
      const { data: result } = await axiosInstanceB2B.get(`${Urls.GetDepartments}`);
      setDepartments(result?.items);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchUserData();
    fetchDepartments();
  }, []);
  const [form] = Form.useForm();
  const handleDepartmentChange = async (values: any) => {
    setDepartmentId(values?.departmentId);
  
    try {
      const { data: result } = await axiosInstanceB2B.get(
        `${Urls.GetDepartmentPreference}/${values?.departmentId}`
      );
  
      const preferences = result?.preferences || [];
      setBusinessPreferences(result?.preferences);
      const getPreference = (key: string) => preferences.find((item: any) => item.key === key);
      const starKey = Object.keys(starSettings)[0]; 
      const starPref = getPreference(starKey);
      if (starPref) {
        const updatedStars = Array(5).fill(false);
        const selectedIndices = starPref.value
          .split(',')
          .map((v: string) => parseInt(v.trim(), 10) - 1)
          .filter((idx: number) => idx >= 0 && idx < 5);
  
        selectedIndices.forEach((idx: number) => {
          updatedStars[idx] = true;
        });
        setStarSettings({ hotel_max_stars: updatedStars });
      } else {
        setStarSettings({ hotel_max_stars: [false, false, false, false, false] });
      }
      const propertyKey = 'hotel_locked_types';
      const propertyPref = getPreference(propertyKey);
      if (propertyPref) {
        const parsedValue = JSON.parse(propertyPref.value);
        setPropertySettings({
          hotel_locked_types: parsedValue,
          hotels: parsedValue.includes('hotels'),
          rentals: parsedValue.includes('rentals'),
          motel: parsedValue.includes('motel'),
        });
      } else {
        setPropertySettings({
          hotel_locked_types: [],
          hotels: false,
          rentals: false,
          motel: false,
        });
      }
      const carKeys = 'car_allow_rental_brand';
      const carPref = getPreference(carKeys);
      if (carPref && carPref.value) {
        const parsedValue = JSON.parse(carPref.value);
        setCarSettings({
          car_allow_rental_brand: parsedValue,
          budget: parsedValue.includes('budget'),
          avis: parsedValue.includes('avis'),
          hertz: parsedValue.includes('hertz'),
          payless: parsedValue.includes('payless'),
          enterprise: parsedValue.includes('enterprise'),
          dollarUs: parsedValue.includes('dollar us'),
          thriftyUs: parsedValue.includes('thrifty us'),
          sixt: parsedValue.includes('sixt'),
          fox: parsedValue.includes('fox'),
          alamo: parsedValue.includes('alamo'),
          national: parsedValue.includes('national'),
        });
      } else {
        setCarSettings({
          car_allow_rental_brand: [],
          budget: false,
          avis: false,
          hertz: false,
          payless: false,
          enterprise: false,
          dollarUs: false,
          thriftyUs: false,
          sixt: false,
          fox: false,
          alamo: false,
          national: false,
        });
      }
      const hotelBudgetKey = 'hotel_max_budget';
      const hotelBudgetPref = getPreference(hotelBudgetKey);
  
      if (hotelBudgetPref && hotelBudgetPref.value.length > 0) {
        setMaxBudgetSettings({ budget: true });
        setHotelMaxBudget(hotelBudgetPref.value);
      } else {
        setMaxBudgetSettings({ budget: false });
        setHotelMaxBudget('');
      }
      const carAmountKey = 'car_max_budget';
      const carAmountPref = getPreference(carAmountKey);
  
      if (carAmountPref && carAmountPref.value.length > 0) {
        setCarBudgetSettings({ maximumCars: true });
        setMaximumCarAmount(carAmountPref.value);
      } else {
        setCarBudgetSettings({ maximumCars: false });
        setMaximumCarAmount('');
      }
  
    } catch (error) {
      Toaster.error(intl.formatMessage({ id: 'error.occurred' }));
    }
  };
  
  const onFinish = async (values: any) => {
  }
  
  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm border mb-5">
              <div className="card-header border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-briefcase mx-2"></i><FormattedMessage id="travel.policies" />
                </h4>
              </div>
              <div className="departmentSearch p-4 pb-0">
                <Form
                  form={form}
                  initialValues={{ state: 'Active' }}
                  onFinish={handleDepartmentChange}
                  layout="vertical"
                  className="mb-0"
                >
                  <Form.Item label={<h6 className="mb-0 fw-bold">Department</h6>} name="departmentId">
                    <Select 
                      placeholder="Default" 
                      className="customSelect"
                      onChange={(value) => {
                        form.setFieldsValue({ departmentId: value });
                        handleDepartmentChange({ departmentId: value });
                      }}
                    >
                      {departments?.map((departments: any, index: number) => (
                        <Option key={index} value={departments.departmentId}>{departments?.departmentName}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Form>
               </div>
              <div className="card-body border-bottom">
                <div className='d-flex justify-content-end'>
                
              </div>
                <div className="travelCard">
                  <div className="travelCard_body d-flex align-items-center justify-content-between">
                    <div className="travelCard_left">
                      <h2>
                       <FormattedMessage id="hotel.policies" />
                      </h2>
                    </div>
                    <div className="travelCard_right text-end">
                    <BlueButton
                        className="w-auto btn d-inline-block btn-primary commonBlueBtn blue-button"
                        onClick={handleSave}
                        disabled={saveLoading?.loading}
                          >
                            {saveLoading?.loading ? (
                              <Spin
                                spinning={saveLoading?.loading}
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '111px', padding: '3px 0' }}
                              ></Spin>
                            ) : (
                              <FormattedMessage id="save.changes" />
                            )}
                    </BlueButton>
                    </div>
                  </div>
                  <div
                    className={`collapse ${loading && 'no-data'} ${isCollapseOpen ? 'show' : ''} `}
                    id="collapseExample"
                  >
                    {loading ? (
                      <>
                        <div className="loading-widget-container text-center d-flex align-items-center justify-content-center">
                          <Spin spinning={loading}></Spin>
                        </div>
                      </>
                    ) : (
                      <>
                        <form className="card-body px-0 pb-0 ratingStar mt-2 mb-4">
                          <h3 className="fs-6 fw-semibold">1. <FormattedMessage id="block.properties" /></h3>
                          {[1, 2, 3, 4, 5].map(i =>
                            renderSwitch(`star-${i}`, `${i}`, starSettings.hotel_max_stars[i - 1])
                          )}
                        </form>
                        <form className="card-body px-0 pb-0 ratingStar mt-2 mb-4">
                          <h3 className="fs-6 fw-semibold">2. <FormattedMessage id="block.budget" /></h3>
                          {budgetOptions?.map((option) => (
                            <div
                              className="form-check form-switch form-check-md d-flex justify-content-between"
                              key={option.id}
                            >
                              <label
                                className="form-check-label ps-0 pe-4 d-flex align-items-center"
                                htmlFor={option.id}
                              >
                                {option.label}
                              </label>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={option.id}
                                checked={option.checked}
                                onChange={handleBudgetChange}
                              />
                            </div>
                          ))}

                          {maxBudgetSettings?.budget && (
                            <div className="my-3 pt-3 d-flex align-items-center justify-content-between">
                                <label className="form-label flex-shrink-0 mb-0"><FormattedMessage id="max.budget" /></label>
                                <div className='d-flex flex-column justify-content-end'>
                                  <div className="input-group">
                                    <span className="input-group-text">$</span>
                                    <input
                                      type="text"
                                      className="form-control form-control-lg"
                                      value={hotelMaxBudget}
                                      onChange={handleTierInputChange}
                                    />
                                    <span
                                      className="input-group-text cursor"
                                    >
                                      <FormattedMessage id="USD.currency" />
                                    </span>
                                  </div>
                                  </div>
                              </div> 
                          )}
                          {tierError && (
                            <div
                              className="text-danger mt-2 d-flex justify-content-end"
                              style={{ fontSize: '0.900rem', fontWeight: 'bold' }}
                            >
                              {tierError}
                            </div>
                          )}
                        </form>
                        <form className="card-body px-0 pb-0 ratingStar mt-2 mb-4">
                          <h3 className="fs-6 fw-semibold">3. <FormattedMessage id="block.property" /></h3>
                          {propertyOptions?.map((option) => (
                            <div
                              className="form-check form-switch form-check-md d-flex justify-content-between"
                              key={option.id}
                            >
                              <label
                                className="form-check-label ps-0 pe-4 d-flex align-items-center"
                                htmlFor={option.id}
                              >
                                {option.label}
                              </label>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={option.id}
                                checked={option.checked}
                                onChange={handlePropertyChange}
                              />
                            </div>
                          ))}
                        </form>
                      </>
                    )}
                  </div>
                </div>
                {/* ----------------cars tab-------------------- */}
                <div className="travelCard mt-3">
                  <div className="travelCard_body d-flex align-items-center justify-content-between">
                    <div className="travelCard_left">
                      <h2><FormattedMessage id="cars.policy" /></h2>
                    </div>

                  </div>
                  <div
                    className={`collapse ${loading && 'no-data'} ${carsIsCollapseOpen ? 'show' : ''} `}
                    id="collapseExample"
                  >
                    <form className="card-body px-0 pb-0 ratingStar mt-2 mb-4">
                      <h3 className="fs-6 fw-semibold">1. <FormattedMessage id="allow.max.budget" /></h3>
                      {carBudgetOptions?.map((option) => (
                        <div
                          className="form-check form-switch form-check-md d-flex justify-content-between"
                          key={option.id}
                        >
                          <label
                            className="form-check-label ps-0 pe-4 d-flex align-items-center"
                            htmlFor={option.id}
                          >
                            {option.label}
                          </label>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={option.id}
                            checked={option.checked}
                            onChange={handleCarBudgetChange}
                          />
                        </div>
                      ))}
                      {carBudgetSettings?.maximumCars && (
                        <div className="my-3 pt-3 d-flex align-items-center justify-content-between">
                          <label className="form-label flex-shrink-0 mb-0"><FormattedMessage id="amount" /></label>
                          <div className="input-group justify-content-end">
                            <span className="input-group-text">$</span>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              value={maximumCarAmount}
                              onChange={handleCarInputChange}
                            />
                            <span className="input-group-text cursor" onClick={handleCarChange}>
                              <FormattedMessage id="USD.currency" />
                            </span>
                          </div>
                        </div>
                      )}
                      {carError && (
                        <div
                          className="text-danger mt-2 d-flex justify-content-end"
                          style={{ fontSize: '0.900rem', fontWeight: 'bold' }}
                        >
                          {carError}
                        </div>
                      )}
                    </form>
                    <form className="card-body px-0 pb-0 ratingStar mt-2 mb-4">
                      <h3 className="fs-6 fw-semibold">2. <FormattedMessage id="allow.specific.car.brands" /></h3>
                      <div className="container-fluid px-0">
                        <div className="row">
                          {carOptions?.reduce((rows: any[], option, idx) => {
                            if (idx % 2 === 0) {
                              // Start a new row with one or two items
                              const secondOption = carOptions[idx + 1];
                              rows.push(
                                <div className="row mb-2" key={`car-row-${idx}`}>
                                  <div className="col-12 col-md-6">
                                    <div
                                      className="form-check form-switch form-check-md d-flex justify-content-between"
                                      key={option.id}
                                    >
                                      <label
                                        className="form-check-label ps-0 pe-4 d-flex align-items-center"
                                        htmlFor={option.id}
                                      >
                                        {option.label}
                                      </label>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={option.id}
                                        checked={option.checked}
                                        onChange={handleCarToggle}
                                      />
                                    </div>
                                  </div>
                                  {secondOption && (
                                    <div className="col-12 col-md-6">
                                      <div
                                        className="form-check form-switch form-check-md d-flex justify-content-between"
                                        key={secondOption.id}
                                      >
                                        <label
                                          className="form-check-label ps-0 pe-4 d-flex align-items-center"
                                          htmlFor={secondOption.id}
                                        >
                                          {secondOption.label}
                                        </label>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={secondOption.id}
                                          checked={secondOption.checked}
                                          onChange={handleCarToggle}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            }
                            return rows;
                          }, [])}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  function renderSwitch(id: string, label: string, checked: boolean): JSX.Element {
    const starCount = parseInt(label);
    return (
      <div className="form-check form-switch form-check-md d-flex justify-content-between" key={id}>
        <label className="form-check-label ps-0 pe-4 d-flex align-items-center" htmlFor={id}>
          {Array.from({ length: starCount || 0 }).map((_, index) => (
            <i
              key={index}
              className="bi bi-star-fill text-warning me-1"
              style={{ fontSize: '1rem' }}
            ></i>
          ))}
          {label}
        </label>
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          checked={checked}
          onChange={handleChange}
        />
      </div>
    );
  }
}

const CompanyTravel = CompanyTravelComponent;
export default CompanyTravel;
